import type { PreferredAirport } from '@/types/clientDetailsApiTypes';

export const getAirportLabel = (airport: PreferredAirport) => {
  const parts = [airport.code, airport.city, airport.country]
    .map((part) => (part && part.trim() ? part.trim() : ''))
    .filter(Boolean);

  if (parts.length === 0) {
    return 'Unknown airport';
  }

  return parts.join(' - ');
};
